import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=32c40be4&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=32c40be4&lang=stylus&scoped=true&"
import style1 from "./ModalHeader.vue?vue&type=style&index=1&id=32c40be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c40be4",
  null
  
)

export default component.exports